import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  chatbotVoiceToText,
  chatbotVoiceToTextSuccess,
} from "../../../store/ChatCrmit/action";
import {
  actionEventFiredSuccess,
  timerNotes,
} from "../../../store/timeEntries/action";
import { isEmpty } from "lodash";

const VoiceToTextAI = ({ popupTimer }) => {
  const dispatch = useDispatch();
  const [recordedVoice, setRecordedVoice] = useState("");
  const [isRecording, setIsRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);

  const { chatbotVoiceToTextData, chatbotVoiceToTextDataLoading } = useSelector(
    (state) => ({
      chatbotVoiceToTextData: state.ChatCrmit?.chatbotVoiceToTextData,
      chatbotVoiceToTextDataLoading:
        state.ChatCrmit?.chatbotVoiceToTextDataLoading,
    })
  );

  useEffect(() => {
    if (chatbotVoiceToTextData?.status !== 200) return;

    dispatch(timerNotes(chatbotVoiceToTextData.response));
    dispatch(actionEventFiredSuccess(true));
    dispatch(chatbotVoiceToTextSuccess([]));
  }, [chatbotVoiceToTextData, dispatch]);

  const startRecording = async () => {
    if (!navigator.mediaDevices?.getUserMedia) {
      alert("Your browser does not support audio recording.");
      return;
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);

      const audioChunks = [];
      recorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunks.push(event.data);
        }
      };

      recorder.onstop = async () => {
        const audioBlob = new Blob(audioChunks, { type: "audio/m4a" });
        const reader = new FileReader();
        reader.onloadend = () => {
          setRecordedVoice(reader.result);
        };
        reader.readAsDataURL(audioBlob);
      };

      recorder.start();
      setMediaRecorder(recorder);
      setIsRecording(true);
    } catch (error) {
      console.error("Error starting audio recording:", error);
      alert("Unable to start recording. Please try again.");
    }
  };

  const stopRecording = () => {
    if (mediaRecorder) {
      mediaRecorder.stop();
      setIsRecording(false);
      setMediaRecorder(null);
    }
  };

  useEffect(() => {
    if (isEmpty(recordedVoice)) return;
    if (recordedVoice) {
      sendTranscript();
    }
  }, [recordedVoice]);

  const sendTranscript = () => {
    dispatch(chatbotVoiceToText({ AudioBase64: recordedVoice }));
    setRecordedVoice("");
  };

  const { rNotes } = useSelector((state) => ({
    rNotes: state.TimeEntries.timeEntryData.timeentry_data.Notes,
  }));

  return (
    <div className={popupTimer ? "" : "page-content"}>
      <div className={popupTimer ? "" : "container-fluid"}>
        <div>
          <div>
            <textarea
              className="form-control"
              placeholder={"Type your notes here or use voice to text"}
              name="textospeach"
              id="texttospeach"
              cols="30"
              rows="2"
              value={rNotes}
              onChange={(e) => {
                dispatch(timerNotes(e.target.value));
                dispatch(actionEventFiredSuccess(true));
              }}
              disabled={chatbotVoiceToTextDataLoading}
            ></textarea>
          </div>
          <div className="mt-2">
            <div className={"d-flex justify-content-between"}>
              <button
                className={`w-100 me-1 btn btn-${
                  isRecording ? "danger" : "success"
                }`}
                onClick={isRecording ? stopRecording : startRecording}
                disabled={chatbotVoiceToTextDataLoading}
              >
                {chatbotVoiceToTextDataLoading ? (
                  <>
                    <i className="fa-solid fa-spinner fa-spin me-1"></i>
                    Processing...
                  </>
                ) : (
                  <>
                    <i
                      className={`fa-solid fa-${
                        isRecording ? "stop" : "microphone"
                      } me-1`}
                    ></i>
                    {isRecording ? "Stop Listening" : "Start Listening"}
                  </>
                )}
              </button>

              <button
                className="btn btn-warning w-100"
                onClick={() => {
                  dispatch(timerNotes(""));
                  dispatch(actionEventFiredSuccess(true));
                }}
                disabled={chatbotVoiceToTextDataLoading}
              >
                {chatbotVoiceToTextDataLoading ? (
                  <>
                    <i className="fa-solid fa-spinner fa-spin me-1"></i>
                    Clearing...
                  </>
                ) : (
                  <>
                    <i className="fa-regular fa-trash-can me-1"></i>
                    Clear Text
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoiceToTextAI;
